import React, { useEffect, useState, useRef } from "react"
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea, Wrap, WrapItem } from "@chakra-ui/react"
import { useTranslation } from "react-i18next";
interface props {
    isModalOpen: boolean;
    onModalClose: () => void;
    setComment: (data: string) => void;
    onConfirm: () => void;
    comment: string;
    reason: any[];
    reasonLoading: boolean | undefined;
    textareaValue: string;
    textareaRef: React.RefObject<HTMLTextAreaElement>;
    handleReasonClick: (text: string) => void;
    handleTextareaChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    handleRejectClose: () => void;
}

export const RejectReason = ({ isModalOpen, onModalClose, setComment, onConfirm, comment, reason,
    reasonLoading,
    textareaValue,
    textareaRef,
    handleReasonClick,
    handleTextareaChange,
    handleRejectClose }: props) => {
    const { t, i18n } = useTranslation("translation");

    return (
        <Modal
            closeOnOverlayClick={false}
            isOpen={isModalOpen}
            onClose={() => {handleRejectClose(); onModalClose();}}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className='!font-normal'>{t("app.enter_decline_reason")}</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    <Wrap spacing={2} mb={4}>
                        {!reasonLoading &&
                            reason.map((r, index) => (
                                <WrapItem key={index}>
                                    <Button size="sm" variant="outline" bg="orange.100" onClick={() => handleReasonClick(r.reason)}>
                                        {r.reason}
                                    </Button>
                                </WrapItem>
                            ))}
                    </Wrap>

                    <Textarea ref={textareaRef}
                        size='lg' className='!h-44 !border-gray-300'
                        value={textareaValue}
                        onChange={handleTextareaChange}
                    />
                </ModalBody>

                <ModalFooter className='gap-4'>
                    <Button colorScheme='orange' variant='outline' className="mr-auto w-full" onClick={() => {handleRejectClose(); onModalClose();}}>{t("app.backspace")}</Button>
                    <Button colorScheme='orange' className="w-full" onClick={() => { onModalClose(); onConfirm();}}>{t("app.confirm")}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}